var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put } from 'redux-saga/effects';
import { getConfigurationDataAction, getConfigurationDataFailureAction, saveBaseTemplateDataAction } from '../actions';
import { BrandedNotificationSaveService } from '../services';
function saveBrandedNotificationConfiguration(branbedNotificationPostService, brandedNotificationPostRequest, coCode) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield branbedNotificationPostService.postBrandedNotificationConfiguration(brandedNotificationPostRequest, coCode);
    });
}
export function* saveBrandedNotificationConfigurationSaga(action, branbedNotificationSaveService = new BrandedNotificationSaveService()) {
    const { brandedNotificationPostRequest, coCode, brandedNotificationInputs } = action.payload;
    try {
        const result = yield call(saveBrandedNotificationConfiguration, branbedNotificationSaveService, brandedNotificationPostRequest, coCode);
        if (result.status) {
            yield put(getConfigurationDataAction(brandedNotificationInputs, coCode, ''));
        }
        else {
            yield put(getConfigurationDataFailureAction(result.errorResponse.errorResponse));
            if (brandedNotificationInputs.baseTemplateInfo &&
                brandedNotificationInputs.baseTemplateInfo.isBaseTemplateSelected)
                yield put(saveBaseTemplateDataAction && saveBaseTemplateDataAction([]));
        }
    }
    catch (error) {
        yield put(getConfigurationDataFailureAction(error.message));
        if (brandedNotificationInputs.baseTemplateInfo && brandedNotificationInputs.baseTemplateInfo.isBaseTemplateSelected)
            yield put(saveBaseTemplateDataAction && saveBaseTemplateDataAction([]));
    }
}
//# sourceMappingURL=saveBrandedNotificationCofigurationSaga.js.map